// Thin, SSR-safe wrapper around Fathom Analytics. The Fathom script is loaded
// in the app layout only when a Site ID is configured (production by default),
// so trackEvent is a no-op everywhere else — callers never need to guard.
declare global {
  interface Window {
    fathom?: {
      trackEvent: (name: string, opts?: { _value?: number }) => void
      trackPageview: (opts?: { url?: string; referrer?: string }) => void
    }
  }
}

export function track(eventName: string): void {
  if (typeof window === "undefined") return
  window.fathom?.trackEvent(eventName)
}

/**
 * Tell Fathom a client-side navigation happened.
 *
 * Fathom's script counts a pageview when it loads and never again. This app is
 * an Inertia SPA, so every in-site click is an XHR — no script re-execution, no
 * pageview. The result was that Fathom only ever saw landing pages and server
 * redirects: over 30 days it recorded 103 visits to `/` and exactly ONE to
 * /apply, while three applications were actually submitted. The whole in-site
 * funnel was invisible.
 *
 * Wired to Inertia's `navigate` event in the client entrypoint. The initial
 * load is skipped because the script already counted it.
 */
export function trackPageview(): void {
  if (typeof window === "undefined") return
  window.fathom?.trackPageview()
}
